export const iconFontAwesomeMathematicsInfinity = (
	<i className="fa-solid fa-infinity"></i>
);
